import type { ModelsInfoTableControllerProps } from "./ModelsInfoTableController";
import { ModelsInfoTableTitle } from "./ModelsInfoTableTitle";

const ModelsInfoTableLg = ({ tableData }: ModelsInfoTableControllerProps) => {
  return (
    <table className="billing-table">
      <tbody>
        <ModelsInfoTableTitle />
        {tableData.map((item, index) => (
          <tr key={index}>
            <td>{item.modelName}</td>
            <td>
              <div>
                <span>{item.tokens.paid}</span>
                <span>{item.tokens.free}</span>
              </div>
            </td>
            <td>{item.costSavings}</td>
            <td>{item.totalCost}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export { ModelsInfoTableLg };
